import { useQuery } from '../use-query';
import { invoicesService } from '../../../services';
import { useStore } from '../../../context';
import { showToRoles } from '../../../utils';
import { INVOICES_MOCK_DATA } from '../../../const';
import { InvoiceGetAllQuery } from '../../../types';

export const useInvoicesByClientYardsQuery = (keys: any = {}) => {
  const {
    state: {
      user: { data: user },
      tutorial,
    },
  } = useStore();

  const enabled =
    (showToRoles(
      ['SUPER_ADMIN', 'YARD_COMPANY_ADMIN', 'YARD_COMPANY_EMPLOYEE', 'YARD_COMPANY_VIEWER'],
      user,
    ) &&
      !!keys.yardId) ||
    !showToRoles(
      ['SUPER_ADMIN', 'YARD_COMPANY_ADMIN', 'YARD_COMPANY_EMPLOYEE', 'YARD_COMPANY_VIEWER'],
      user,
    );

  return useQuery(
    ['invoices', 'client-yards', JSON.stringify(keys), JSON.stringify(tutorial)],
    () => {
      if (tutorial.isActive) return Promise.resolve({ data: [INVOICES_MOCK_DATA], totalCount: 1 });

      if (!enabled) return Promise.resolve({ data: [], totalCount: 0 });

      return invoicesService
        .getByClientYards({
          params: keys,
        })
        .then((res) => res.data);
    },
    { initialData: { data: [], totalCount: 0 }, keepPreviousData: true },
  );
};

export const initialInvoiceGetAllQuery: InvoiceGetAllQuery = {
  data: [],
  totalCount: 0,
  minDate: {
    ALL: '',
    STORAGE: '',
    CRANE: '',
    OTHER: '',
  },
  createMode: 'AUTO',
  clientYard: { yard: { name: '' }, client: { code: '' } },
};

export const useInvoicesQuery = ({ clientYardId, ...keys }: any = {}) => {
  return useQuery(
    ['invoices', clientYardId, JSON.stringify(keys)],
    () => {
      return invoicesService
        .getAll(clientYardId, {
          params: keys,
        })
        .then((res) => res.data);
    },
    {
      initialData: initialInvoiceGetAllQuery,
      keepPreviousData: true,
      enabled: !!clientYardId,
    },
  );
};

export const useInvoiceQuery = (invoiceId = '') =>
  useQuery(
    ['invoice', invoiceId],
    () => {
      return invoicesService.getOne(invoiceId).then((res) => res.data.data);
    },
    {
      initialData: { data: {} },
      enabled: !!invoiceId,
    },
  );
